import React from 'react';
import {Modal} from 'react-bootstrap';
import classNames from 'classnames';
import styles from './styles.module.scss';

const ModalContainer = ({
                          show,
                          size = 'lg',
                          onHide,
                          children = <div/>,
                          customClassnames = ''
                        }) => {
  const getSize = () => {
    switch (size) {
      case 'xxl': return styles.xxlWidth
      case 'xxxl': return styles.xxxlWidth
      default: return size
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size={getSize() === 'xxl' || getSize() === 'xxxl' ? undefined : size}
      className={classNames('bg-transparent', customClassnames)}
      contentClassName={styles.content}
      overlayClassName={styles.overlay}
      dialogClassName={getSize()}
    >
      <Modal.Body className={styles.modalContainer}>
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default ModalContainer;